module.exports = __webpack_public_path__ + "img/metodologia.2a028a53.webp";